// eslint-disable-next-line import/no-cycle
import axios from '@/core/plugins/axios';

const baseUrl = import.meta.env.VITE_API_STORIES;
const headers = {
  'Content-Type': 'application/json; Charset=UTF-8',
};

export default {
  getNarrators(options = null) {
    let params = null;

    if (options) {
      const {
        offset = 0,
        limit = 10,
        keyword = '',
        type = '',
        sort = '',
      } = options;

      params = {
        offset,
        fetchLimit: limit,
        search: keyword,
      };

      if (sort) {
        params.sortColumns = type;
        params.sortColumnOrders = sort;
      }
    }

    return axios({
      method: 'get',
      url: `${baseUrl}/narrators`,
      headers,
      params,
    });
  },
  getNarrator(id) {
    const params = {
      narratorId: id,
    };

    return axios({
      method: 'get',
      url: `${baseUrl}/narrator`,
      headers,
      params,
    });
  },
  createNarrator(data) {
    return axios({
      method: 'post',
      url: `${baseUrl}/narrator`,
      headers,
      data,
    });
  },
  updateNarrator(data) {
    return axios({
      method: 'put',
      url: `${baseUrl}/narrator`,
      headers,
      data,
    });
  },
  deleteNarrator(id) {
    const params = {
      narratorId: id,
    };

    return axios({
      method: 'delete',
      url: `${baseUrl}/narrator`,
      headers,
      params,
    });
  },
};
